import moment from 'moment-timezone'
import {arrayToJSONString} from '@/utilities/filters/array-to-jsonstring'
import {specialCharacters} from '@/utilities/regex/special-characters'

export default class SearchQuery {
  constructor (collection = [], searchProperties = {}) {
    Object.assign(this, { searchProperties })

    this.cachedData = []
    this.searchTags = [] // tags
    this.searchNameKeys = [] // tags
    this.queriedData = [] // recordset of returned queried recordset

    this.setSearchPropertyNameKey(this.searchProperties)
    this.copySearchCache(collection.models) // original recordset
  }

  getCount () {
    return this.cachedData.length
  }

  getQueriedCount () {
    return this.queriedData.length
  }

  /**
   *
   * Method to retrieve property 'name' of search properties.
   * Assuming this property is used for display.
   *
   */
  setSearchPropertyNameKey (searchProperties) {
    if (_.isUndefined(searchProperties) || searchProperties.length === 0) {
      this.searchNameKeys.length = 0
    } else {
      this.searchNameKeys = _.map(searchProperties, 'name')
    }
  }

  /**
   * JSON Stringify record based on search property keys.
   *
   * @param {*} jsonData
   * @param {*} searchPropertyArray
   */
  convertToJSONString (jsonData, searchPropertyArray) {
    let jsonString = ''
    // global regex
    let specialCharRegex = new RegExp(specialCharacters, 'g')

    for (let key in jsonData) {
      let attrValue = _.cloneDeep(jsonData[key])
      let propertyKey = null
      if (typeof attrValue === 'object') {
        // TODO: NOT fool proof
        propertyKey = _.find(searchPropertyArray, function (field) {
          return field.name.startsWith(key)
        })
      } else {
        propertyKey = _.find(searchPropertyArray, { name: key })
      }

      // check if field is visible key to be searched on
      if (!_.isUndefined(propertyKey)) {
        if (_.isArray(attrValue)) {
          // In case of array of objects, object is stringified first.
          if (propertyKey.datatype === 'objectpath') {
            attrValue = _.get(jsonData, propertyKey.name)
          } else {
            for (let index = 0; index < attrValue.length; index++) {
              attrValue[index] = arrayToJSONString(attrValue[index])
            }
            // for array types, join each item with '|'
            attrValue = attrValue.join('|')
          }
          // globally replace all special characters
          let searchObject = attrValue.replace(specialCharRegex, '')
          // search will be case insensitive
          jsonString += String(searchObject).toLowerCase() + ','
        } else {
          if (propertyKey.datatype === 'datetime') {
            attrValue = moment(attrValue).format(propertyKey.format)
          } else if (propertyKey.datatype === 'objectpath') {
            attrValue = _.get(jsonData, propertyKey.name)
          }
          // search will be case insensitive
          jsonString += String(attrValue).toLowerCase() + ','
        }
      }
    }

    return jsonString
  }

  /**
   * Copy original dataset and map new field 'stringify' to stringified values of row/record.
   * Field stringify will be used to for search.
   *
   * @param {*} dataSet
   */
  copySearchCache (dataSet) {
    if (!dataSet) {
      return dataSet
    }

    this.cachedData = []
    for (let idx in dataSet) {
      // deep copy record as we will mutate it
      let record = _.cloneDeep(dataSet[idx])
      if (_.isUndefined(this.searchProperties) || this.searchProperties.length === 0) {
        record.stringify = JSON.stringify(record)
      } else {
        record.stringify = this.convertToJSONString(record, this.searchProperties)
      }
      this.cachedData.push(record)
    }
  }

  searchData (searchTags) {
    // if no search tags, return all data
    if (searchTags.length === 0) {
      this.searchTags.length = 0
      return _.cloneDeep(this.cachedData)
    } else {
      if (searchTags) {
        // if search tag is added, continue search an queriedData
        if (searchTags.length > 1 && searchTags.length > this.searchTags.length) {
          let newTags = _.difference(_.map(searchTags, 'text'), this.searchTags)
          let indexesToBeDeleted = []

          this.queriedData.forEach((row, index) => {
            // if row doesn't match search, remove
            newTags.forEach(tag => {
              if (!this.checkRowForSearchTag(tag, row, index)) {
                indexesToBeDeleted.push(index)
              }
            })
          })

          for (let idx = indexesToBeDeleted.length - 1; idx >= 0; idx--) {
            this.queriedData.splice(indexesToBeDeleted[idx], 1)
          }
        } else {
          // two cases here
          // 1. first tag added
          // 2. tag removed, in which case empty queried data and search on cachedData
          if (this.queriedData.length > 0) {
            this.queriedData.length = 0
          }

          this.cachedData.forEach((row, index) => {
            _.map(searchTags, 'text').forEach(tag => {
              if (this.checkRowForSearchTag(tag, row, index)) {
                this.queriedData.push(row)
              }
            })
          })
        }
      }
      this.searchTags = _.map(searchTags, 'text')
      return this.queriedData
    }
  }

  /**
   * Search record for tag (ignorecase)
   * @param {*} searchTag
   * @param {*} row
   * @param {*} index
   *
   */
  checkRowForSearchTag (searchTag, row, index) {
    return row.stringify.includes(searchTag.toLowerCase())
  }

  /**
   * Search dataset by individual properties
   *
   * @param {*} searchTags
   * @param {*} searchField
   */
  searchDataByProperty (searchTags, searchField) {
    let match = false
    // global regex
    let specialCharRegex = new RegExp(specialCharacters, 'g')
    this.queriedData.length = 0

    this.cachedData.forEach(
      function (row, index) {
        match = false
        if (!_.isUndefined(row[searchField]) && !_.isUndefined(searchTags)) {
          let value
          if (_.isArray(row[searchField])) {
            let arrayValue = row[searchField].toString().replace(specialCharRegex, '')
            value = arrayValue.toString().toLowerCase()
          } else {
            value = row[searchField].toString().toLowerCase()
          }
          searchTags.forEach(function (searchTag) {
            if (value === searchTag.toLowerCase()) {
              match = true
            }
          })
        }

        if (!match) {
          // do nothing on not found
        } else {
          this.queriedData.push(row)
        }
      }.bind(this)
    )
    return this.queriedData
  }
}



// WEBPACK FOOTER //
// ./src/resources/query/SearchQuery.js